import newRequest from '@/utils/new-request';

const baseFinanceURL = process.env.VUE_APP_FINANCE;

// 揽收每日应收统计 分页
export const apiStatisticsPage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/statistics/page',
    data
  });
};

// 揽收每日应收统计 刷新数据
export const apiStatisticsAgainStatistics = (time) => {
  return newRequest({
    method: 'GET',
    url: `/statistics/againStatistics?time=${time}`
  });
};

// 揽收每日应收统计 导出文件
export const apiStatisticsExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/statistics/export',
    data
  });
};

/**
 * 应收看板 获取token
 * @param {*} type
 *        5: 财务应收看板-总览
 *        6: 财务应收看板-业务总览明细
 *        7: 财务应收看板-客户总览明细
 * @returns
 */
export const getDashboardParams = (type) => {
  return newRequest({
    method: 'get',
    url: `/bi/api/createEmbedPageToken?type=${type}`,
    baseURL: baseFinanceURL
  });
};

/**
 * 飞书费用-分页
 */
export const apiFeishuExpensePage = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkExpense/pageList',
    baseURL: baseFinanceURL,
    data,
    isLoading: true
  });
};

/**
 * 飞书费用-导出列表
 */
export const apiFeishuExpenseExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkExpense/export',
    data,
    isLoading: false
  });
};

/**
 * 飞书费用-全量导出（含附件）
 */
export const apiFeishuExpenseExportAll = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkExpense/exportAll',
    data,
    isLoading: false
  });
};

/**
 * 飞书费用-导出附件
 * @param {*} id
 */
export const apiLarkExpenseExportAttachment = (id) => {
  return newRequest({
    method: 'POST',
    url: `/larkExpense/exportAttachment/${id}`,
    isLoading: true
  });
};

/**
 * 飞书费用-汇率维护列表
 */
export const apiFeishuExpenseExchangeRate = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkCurrencyRate/pageList',
    baseURL: baseFinanceURL,
    data,
    isLoading: false
  });
};

/**
 * 飞书费用-汇率维护-保存
 */
export const apiFeishuExpenseExchangeRateSave = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkCurrencyRate/add',
    baseURL: baseFinanceURL,
    data,
    isLoading: false
  });
};

/**
 * 飞书费用-汇率维护-修改
 */
export const apiFeishuExpenseExchangeRateUpdate = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkCurrencyRate/edit',
    baseURL: baseFinanceURL,
    data,
    isLoading: true
  });
};

/**
 * 飞书费用-汇率维护-删除
 */
export const apiFeishuExpenseExchangeRateDelete = (id) => {
  return newRequest({
    method: 'POST',
    url: `/larkCurrencyRate/remove/${id}`,
    baseURL: baseFinanceURL,
    isLoading: true
  });
};

/**
 * 飞书-应收账单
 */
export const apiLarkReceivableBillApi = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkReceivableBill/page',
    baseURL: baseFinanceURL,
    data,
    isLoading: true
  });
};

/**
 * 飞书-应收账单-导出附件
 * @param {*} id
 */
export const apiLarkReceivableBillExportAttachment = (id) => {
  return newRequest({
    method: 'POST',
    url: `/larkReceivableBill/exportAttachment/${id}`,
    isLoading: true
  });
};

/**
 * 飞书-应收账单-导出
 */
export const apiLarkReceivableBillExport = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkReceivableBill/export',
    data,
    isLoading: false
  });
};

/**
 * 飞书-应付账单-导出-含附件
 */
export const apiLarkReceivableBillExportZip = (data) => {
  return newRequest({
    method: 'POST',
    url: '/larkReceivableBill/exportAll',
    data,
    isLoading: false
  });
};
